import React, { useContext } from 'react'
import * as Styled from './StructuredQualityReport.styles'
import { string } from 'prop-types'

// component stack
import { TextBox } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

const StructuredQualityReport = ({ urlToPdf }) => {
  const textContext = useContext(TextContext)

  return (
    <TextBox title='Strukturierter Qualitätsbericht (SQB)'>
      <Styled.StructuredQualityReport>
        <p>{textContext['structuredQualityReport.text_1']}</p>
        <p>{textContext['structuredQualityReport.text_2']}</p>
        <div>
          <a
            className='btn'
            href={ urlToPdf }
            target='_blank'
            rel='noopener noreferrer'
            title={ textContext['structuredQualityReport.download.link'] }>
            {textContext['structuredQualityReport.download.link']}
          </a>
        </div>
      </Styled.StructuredQualityReport>
    </TextBox>
  )
}

StructuredQualityReport.defaultProps = {
  urlToPdf: string.isRequired,
}

export default StructuredQualityReport
